export const DISABLED_COMMUNITY_EXPERIENCE_AVAILABILITY = Object.freeze({
  enabled: false,
  approvedLocales: Object.freeze([]),
  collectionNoticeVersion: null,
  ageAttestationVersion: null,
  publicationNoticeVersion: null,
  publicSurface: null,
  authorizedUseKinds: Object.freeze([]),
});

export const isCommunityExperienceAvailable = (availability, resolvedLanguage) =>
  availability?.enabled === true &&
  resolvedLanguage === 'en' &&
  availability.approvedLocales?.includes('en') === true;
